module.exports = __webpack_public_path__ + "static/media/ic-edit.5a6863de.svg";